import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import AboutNordputzHero from "./sections/AboutNordputzHero";
import MeetRameshDevTrustedSpiritualAdvisor from "./sections/MeetRameshDevTrustedSpiritualAdvisor";
import OurCounselingCoachingServices from "./sections/OurCounselingCoachingServices";
import InteriorExteriorPainting from "./sections/InteriorExteriorPainting";
import IndustrialCommercialPainting from "./sections/IndustrialCommercialPainting";
import PreparationFinishing from "./sections/PreparationFinishing";
import ServiceAreas from "./sections/ServiceAreas";
import Yhteystiedot from "./sections/Yhteystiedot";
import CoastalFootnotes from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <AboutNordputzHero />
      <MeetRameshDevTrustedSpiritualAdvisor />
      <OurCounselingCoachingServices />
      <InteriorExteriorPainting />
      <IndustrialCommercialPainting />
      <PreparationFinishing />
      <ServiceAreas />
      <Yhteystiedot />
      <CoastalFootnotes />
    </div>;
}